<template>
  <div class="parents">
    <div class="top-content">
      <svg-icon icon-class="bg" class="bg"></svg-icon>
      <div class="content">
        <p>20%折扣 | 课程优惠即将结束</p>
        <div class="word">
          <p class="white-word">百年名校内锻造内容</p>
          <p>让您的孩子有一群来自名校的同学，学习同一门课</p>
          <p class="white-word">基于美国NGSS和CSTA建立的课程体系</p>
          <p>6-17岁青少年全覆盖，图形化/文本编程/人工智能/机器人/STEAM全领域</p>
        </div>

        <Anchor :affix="false" class="btn">
          <AnchorLink href="#basic_parent" title="让您的孩子开始" />
        </Anchor>
      </div>
    </div>
    <div class="part">
      <p class="title">适合所有年龄段学习的编程课程</p>
      <p class="tip">包含scratch，python，java等多种语言学习</p>
      <div class="part1">
        <div class="rank">
          <div @click="courseType='';getActivityList()">
            <svg-icon icon-class="r1"></svg-icon>
            <p>全部</p>
          </div>
          <div @click="courseType=4;getActivityList()">
            <svg-icon icon-class="r2"></svg-icon>
            <p>机器人</p>
          </div>
          <div @click="courseType=1;getActivityList()">
            <svg-icon icon-class="r3"></svg-icon>
            <p>scratch</p>
          </div>
          <div @click="courseType=6;getActivityList()">
            <svg-icon icon-class="r4"></svg-icon>
            <p>竞赛班</p>
          </div>
          <div @click="courseType=2;getActivityList()">
            <svg-icon icon-class="r5"></svg-icon>
            <p>python</p>
          </div>
          <div @click="courseType=7;getActivityList()">
            <svg-icon icon-class="r6"></svg-icon>
            <p>我的世界</p>
          </div>
        </div>
        <Row type="flex" align="middle" justify="center">
          <i-col span="4">
            <Button
              :class="'btn ' + (suitableAge === 1 ? 'active' : '')"
              size="large"
              shape="circle"
              @click="suitableAge=1;getActivityList()"
            >6-10岁</Button>
          </i-col>
          <i-col span="5">
            <Button
              size="large"
              shape="circle"
              :class="'btn ' + (suitableAge === 2 ? 'active' : '')"
              @click="suitableAge=2;getActivityList()"
            >11-13岁</Button>
          </i-col>
          <i-col span="5">
            <Button
              size="large"
              shape="circle"
              :class="'btn ' + (suitableAge === 3 ? 'active' : '')"
              @click="suitableAge=3;getActivityList()"
            >13岁以上</Button>
          </i-col>
        </Row>
        <Row type="flex" style="margin-top: 20px; padding-left: 20px">
          <i-col span="6" class="card-list" v-for="(item, index) in activityList" :key="index">
            <Card :shadow="true" class="card">
              <div class="pic">
                <img @click="toGoodsDetail(item.id)" :src="item.activityCoverFileUrl" alt />
              </div>
              <div class="content">
                <p class="title" @click="toGoodsDetail(item.id)">{{ item.activityName }}</p>
                <Row type="flex" justify="space-between" style="margin: 5px 0;">
                  <i-col span="8">初学者</i-col>
                  <i-col span="8">scrach</i-col>
                </Row>
                <Row type="flex" justify="space-between">
                  <i-col span="24" @click="toGoodsDetail(item.id)">
                    {{
                    item.activityDesc
                    }}
                  </i-col>
                </Row>
              </div>
            </Card>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="part part2">
      <p class="title">经验证的教学实践和学习方式</p>
      <p class="tip">让孩子还玩耍中学习</p>
      <div class="part-content">
        <div class="bg">
          <svg-icon icon-class="bg2"></svg-icon>
          <div class="s"></div>
        </div>

        <Row type="flex" class="exp" justify="space-between">
          <i-col span="6" class="card-list2">
            <Card :shadow="true" class="card">
              <div class="pic">
                <svg-icon icon-class="theme"></svg-icon>
              </div>
              <ul class="card-content">
                <li class="title">6-10岁</li>
                <li class="word-content">开始使用代码</li>
                <li class="word-content">解决逻辑问题</li>
                <li class="word-content">精通编码基础</li>
              </ul>
            </Card>
          </i-col>
          <i-col span="6" class="card-list2">
            <Card :shadow="true" class="card">
              <div class="pic" style="background-color: rgba(109, 202, 157, 1);">
                <svg-icon icon-class="theme"></svg-icon>
              </div>
              <ul class="card-content">
                <li class="title">11-13岁</li>
                <li class="word-content">构建应用程序</li>
                <li class="word-content">探索steam</li>
                <li class="word-content">设计玩具</li>
              </ul>
            </Card>
          </i-col>
          <i-col span="6" class="card-list2">
            <Card :shadow="true" class="card">
              <div class="pic" style="background-color: rgba(56, 183, 223, 1); ">
                <svg-icon icon-class="theme"></svg-icon>
              </div>
              <ul class="card-content">
                <li class="title">13岁以上</li>
                <li class="word-content">真正使用代码</li>
                <li class="word-content">解决实际问题</li>
                <li class="word-content">培养独立编程</li>
              </ul>
            </Card>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="part3" id="basic_parent">
      <p class="title">选择适合您孩子的学习计划</p>
      <div class="tabs-type">
        <span class="active">6-10岁</span>
        <span>11-13岁</span>
        <span>13岁以上</span>
      </div>
      <Row type="flex" justify="space-around">
        <i-col span="6" class="card-list3">
          <Card :shadow="true" class="card">
            <div class="pic">机器人1级</div>
            <div class="content">
              <p>￥1999</p>
              <span>32课时</span>
            </div>
            <Row class="btns" type="flex" justify="space-between">
              <Poptip width="200" placement="bottom">
                <span>加入购物车</span>
                <div class="api" slot="content">
                  <img src="@/assets/common/logo.png" alt />
                  <Row type="flex" align="middle">
                    <i-col span="6">
                      <svg-icon icon-class="wx1"></svg-icon>
                    </i-col>
                    <i-col span="18">
                      打开 微信 扫一扫
                      <br />完成购买
                    </i-col>
                  </Row>
                </div>
              </Poptip>
              <i-col span="11">
                <router-link to="/course-detail">课程详情</router-link>
              </i-col>
            </Row>
          </Card>
        </i-col>
        <i-col span="6" class="card-list3">
          <Card :shadow="true" class="card">
            <div class="pic">python1级</div>
            <div class="content">
              <p>￥3999</p>
              <span>32课时</span>
            </div>
            <Row class="btns" type="flex" justify="space-between">
              <Poptip width="200" placement="bottom">
                <span>加入购物车</span>
                <div class="api" slot="content">
                  <img src="@/assets/common/logo.png" alt />
                  <Row type="flex" align="middle">
                    <i-col span="6">
                      <svg-icon icon-class="wx1"></svg-icon>
                    </i-col>
                    <i-col span="18">
                      打开 微信 扫一扫
                      <br />完成购买
                    </i-col>
                  </Row>
                </div>
              </Poptip>
              <i-col span="11">
                <router-link to="/course-detail">课程详情</router-link>
              </i-col>
            </Row>
          </Card>
        </i-col>
        <i-col span="6" class="card-list3">
          <Card :shadow="true" class="card">
            <div class="pic">scratch1级</div>
            <div class="content">
              <p>￥2999</p>
              <span>32课时</span>
            </div>
            <Row class="btns" type="flex" justify="space-between">
              <i-col span="9">
                <Poptip width="200" placement="bottom">
                  <span>加入购物车</span>
                  <div class="api" slot="content">
                    <img src="@/assets/common/logo.png" alt />
                    <Row type="flex" align="middle">
                      <i-col span="6">
                        <svg-icon icon-class="wx1"></svg-icon>
                      </i-col>
                      <i-col span="18">
                        打开 微信 扫一扫
                        <br />完成购买
                      </i-col>
                    </Row>
                  </div>
                </Poptip>
              </i-col>
              <i-col span="11">
                <router-link to="/course-detail">课程详情</router-link>
              </i-col>
            </Row>
          </Card>
        </i-col>
      </Row>
    </div>
    <div class="part4">
      <p>受到多所名校的信赖</p>
      <div class="school">
        <img src="@/assets/home/x1.png" alt />
        <img src="@/assets/home/x2.png" alt />
        <img src="@/assets/home/x3.png" alt />
        <img src="@/assets/home/x2.png" alt />
        <img src="@/assets/home/x1.png" alt />
      </div>
      <p>少儿编程教学方式</p>
      <div class="small-title">让孩子在玩耍中学习</div>
      <Row class="div" type="flex" justify="space-around">
        <i-col span="12">
          <img src="@/assets/parents/u1.png" style="width: 529px; height: 318px" />
        </i-col>
        <i-col sppan="10" class="explain">
          <p class="green">故事化的学习内容</p>
          <p>少儿编程的自我指导课程使孩子们可以在有趣的交互式环境中按照自己的节奏学习。</p>
          <p class="green">内置AI课程导师</p>
          <p>分步教程教孩子如何应用编码概念，以便他们可以完成每个项目。</p>
          <p class="green">游戏模式赋能</p>
          <p>完成教程后，孩子们将运用他们学到的概念，并尝试自己所构建的内容。</p>
        </i-col>

        <i-col sppan="12" class="explain">
          <p class="green">互动说明</p>
          <p>很酷的字符介绍了代码块以及如何使用它们。</p>
          <p class="green">入门视频</p>
          <p>H5的短片演示了常见操作，让孩子和内容互动起来。更深刻理解和掌握知识点</p>
          <p class="green">迷你游戏</p>
          <p>预览您在每课中制作的游戏，并在此过程中发布到社区，让孩子的学习更有成就感</p>
        </i-col>
        <i-col span="10">
          <img src="@/assets/parents/u2.jpg" />
        </i-col>

        <i-col span="12">
          <img src="@/assets/parents/u3.jpg" />
        </i-col>
        <i-col sppan="10" class="explain">
          <p class="green">独立游戏建设</p>
          <p>一旦收到提示，孩子们将根据分步说明创建游戏和项目。</p>
          <p class="green">DIY项目</p>
          <p>孩子们将学到的知识运用到自己的独特游戏中。</p>
          <p class="green">易于使用</p>
          <p>拖放界面使构建游戏变得非常容易。借助可嵌入程序的200多个可视块，孩子们甚至可以轻松构建最复杂的游戏。</p>
        </i-col>

        <i-col sppan="12" class="explain">
          <p class="green">创建账户</p>
          <p>能够创建一个家长的账户，购买想要的课程。</p>
          <p class="green">管理孩子的学习</p>
          <p>在账户中可以管理孩子的学习进度。</p>
          <p class="green">易于使用</p>
          <p>账户简介，容易使用，轻松掌握孩子的所有学习情况。</p>
        </i-col>
        <i-col span="10">
          <img src="@/assets/parents/u4.png" />
        </i-col>
      </Row>
      <svg-icon icon-class="bg3" class="bg3"></svg-icon>
    </div>
    <div class="collaspe">
      <a href="javascript: viod(0)" class="btn">让您的孩子开始</a>
      <p>常见问题</p>
      <Collapse simple>
        <Panel name="1">
          我的孩子学编程有什么用？
          <p slot="content">
            少儿编程课程教授21世纪的关键技能，
            包括计算机编程，批判性思维和问题解决能力。
            学生将学习如何按照逻辑顺序对事件进行排序，
            创建可玩的游戏，讲故事并为真实情况建模。
            他们还通过开发算法和设计思维能力来学习计算思维。
          </p>
        </Panel>

        <Panel name="2">
          购买的课程可以重复观看吗？
          <p slot="content">
            少儿编程课程教授21世纪的关键技能， 包括计算机编程，
            批判性思维和问题解决能力。
            学生将学习如何按照逻辑顺序对事件进行排序， 创建可玩的游戏，
            讲故事并为真实情况建模。
            他们还通过开发算法和设计思维能力来学习计算思维。
          </p>
        </Panel>

        <Panel name="3">
          如何为多个孩子提供折扣？
          <p slot="content">
            少儿编程课程教授21世纪的关键技能，
            包括计算机编程，批判性思维和问题解决能力。
            学生将学习如何按照逻辑顺序对事件进行排序，
            创建可玩的游戏，讲故事并为真实情况建模。
            他们还通过开发算法和设计思维能力来学习计算思维。
          </p>
        </Panel>

        <Panel name="4">
          我的多个孩子可以共用一个账户吗？
          <p slot="content">
            少儿编程课程教授21世纪的关键技能，
            包括计算机编程，批判性思维和问题解决能力。
            学生将学习如何按照逻辑顺序对事件进行排序，
            创建可玩的游戏，讲故事并为真实情况建模。
            他们还通过开发算法和设计思维能力来学习计算思维。
          </p>
        </Panel>
      </Collapse>
    </div>
  </div>
</template>
<script>
import { getActivityList, getBuyLink } from "@/api/buy";
export default {
  data() {
    return {
      list: [{}, {}, {}, {}, {}, {}],
      type: "preWeek",
      activityList: [],
      courseType: "",
      suitableAge: "",
    };
  },
  mounted() {
    this.getActivityList();
  },
  methods: {
    toDetail() {},
    getActivityList() {
      //type, courseType, suitableAge,status, limit
      getActivityList("", this.courseType,this.suitableAge, "", 8).then((res) => {
        if (res.success) {
          this.activityList = res.result;
        }
      });
    },
    toGoodsDetail(actId) {
      this.$router.push({
        path: `/goodsDetail?actId=${actId}`,
      });
    },
  },
};
</script>
<style lang="scss">
.parents {
  .ivu-card-shadow {
    box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
    .ivu-card-body {
      padding: 0;
    }
  }
  .ivu-anchor-ink {
    display: none;
  }
  .ivu-anchor-link {
    padding: 14px 16px;
  }
  .collaspe {
    .ivu-collapse,
    .ivu-collapse > .ivu-collapse-item {
      border: none;
    }
    .ivu-collapse-header {
      height: 42px;
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #7e8285;
      text-align: left;
    }
    .ivu-collapse-item-active {
      .ivu-collapse-header {
        color: #5cbe5a;
      }
    }
    .ivu-collapse-content-box {
      font-size: 18px;
      padding-left: 32px;
    }
  }
}
</style>
<style lang="scss" scoped>
.parents {
  background: #fff;
  margin-top: -84px;
  position: relative;
  overflow-x: hidden;
  .top-content {
    width: 100%;
    height: 733px;

    .bg {
      position: absolute;
      left: -350px;
      top: 0;
      width: 2280px;
      height: 733px;
    }
    .content {
      position: absolute;
      top: 80px;
      text-align: center;
      width: 100%;
      > p {
        height: 56px;
        background-color: rgba(191, 16, 61, 1);
        font-size: 18px;
        color: #fff;
        line-height: 56px;
        font-weight: 700;
      }
      .word {
        margin-top: 100px;
        p {
          color: #95f204;
          font-size: 28px;
          font-weight: 400;
          margin-bottom: 30px;
          &.white-word {
            margin-bottom: 0;
            color: #fff;
            font-size: 48px;
          }
        }
      }
      .btn {
        font-weight: 700;
        background: rgba(255, 141, 26, 1);
        font-size: 15px;
        line-height: 40px;
        border-radius: 6px;
        display: inline-block;
        width: 142px;
      }
    }
  }
  .part {
    width: 960px;
    margin: 0 auto;
    > .title {
      color: #629bde;
      font-size: 35px;
      font-weight: 400;
      margin-top: 50px;
    }
    > .tip {
      color: #629bde;
      font-size: 20px;
      line-height: 50px;
      margin-bottom: 10px;
    }
    .btn {
      font-size: 16px;
      padding: 0 28px;
      color: #575757;
      background-color: rgba(228, 228, 228, 1);
      border: none;
      &:hover {
        color: rgb(0, 188, 212);
      }
      &.active {
        background-color: rgba(13, 135, 199, 1);
        color: #fff;
      }
    }
    .part1 {
      position: relative;
      .card-list {
        margin-bottom: 20px;
        &:last-child {
          margin-right: 0;
        }
        .card {
          width: 217px;
          text-align: left;
          color: #999;
          .pic {
            width: 100%;
            height: 125px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              transition: all 0.2s ease-out;
              &:hover {
                transform: scale(1.05);
              }
            }
          }
          .content {
            padding: 6px 20px;
            border-bottom: 1px solid #e8e8e8;
            .title {
              color: #666;
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
      }
      .rank {
        z-index: 999;
        background: #fff;
        position: absolute;
        left: -90px;
        top: 54px;
        padding: 15px 0;
        width: 77px;
        text-align: center;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3490196);
        svg {
          width: 45px;
          height: 45px;
          cursor: pointer;
        }
        p {
          margin-top: 5px;
          margin-bottom: 20px;
          font-size: 14px;
          color: #a4a1fc;
        }
      }
    }
  }
  .part2 {
    width: 1205px;
    height: 500px;
    position: relative;
    .bg {
      position: absolute;
      left: 0;
      top: 30px;
      svg {
        width: 1205px;
        height: 276px;
      }
      .s {
        display: inline-block;
        width: 100%;
        height: 150px;
        background: #edf8ff;
        margin-top: -75px;
      }
    }
    .exp {
      margin-top: 20px;
      padding-left: 20px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(22%);
      width: 800px;
    }
    .part-content {
      text-align: center;
      position: absolute;
      .card-list2 {
        margin-bottom: 20px;
        &:last-child {
          margin-right: 0;
        }
        .card {
          width: 231px;
          text-align: left;
          color: #999;
          box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
          .pic {
            width: 100%;
            height: 131px;
            background: rgba(251, 220, 113, 1);
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
            svg {
              width: 179px;
              height: 97px;
              position: absolute;
              top: 60px;
              left: 50%;
              box-shadow: 0 5px 5px rgba(0, 0, 0, 0.35);
              transform: translateX(-50%);
            }
          }
          .card-content {
            color: #629bde;
            text-align: center;
            padding: 50px 0px 15px;
            width: 98px;
            margin: 0 auto;
            border-bottom: 1px solid #e8e8e8;
            .title {
              font-size: 20px;
              font-weight: 700;
              margin-bottom: 15px;
            }
            .word-content {
              list-style-type: disc;
              font-size: 16px;
              text-align: left;
            }
          }
        }
      }
    }
  }
  .part3 {
    width: 1205px;
    height: 561px;
    margin: 0 auto;
    padding: 40px 0;
    margin-top: -3px;
    background: linear-gradient(
      0deg,
      rgba(194, 233, 251, 1) 0%,
      rgba(161, 196, 253, 1) 101%
    );
    text-align: center;
    .title {
      font-size: 36px;
      color: #fff;
    }
    .tabs-type {
      font-size: 0;
      margin: 30px 0 40px 0;
      span {
        color: #fff;
        width: 90px;
        height: 36px;
        display: inline-block;
        line-height: 36px;
        border: 1px solid #fff;
        font-size: 14px;
        &.active {
          color: rgb(133, 148, 170);
          background: #fff;
          border-color: #fff;
        }
        &:first-child {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          border-right: 0;
        }
        &:nth-child(3) {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          border-left: 0;
        }
      }
    }
    .card-list3 {
      margin-bottom: 20px;
      &:last-child {
        margin-right: 0;
      }
      .card {
        width: 270px;
        text-align: center;
        color: #999;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
        .pic {
          width: 100%;
          line-height: 91px;
          background: rgba(111, 134, 214, 1);
          font-size: 24px;
          font-weight: 700;
          color: #fff;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
        }
        .content {
          padding: 6px 20px;
          margin: 20px 0;
          p {
            color: #333;
            font-size: 20px;
            font-weight: bold;
          }
          span {
            color: #cbcbcb;
            font-size: 13px;
            font-weight: bold;
          }
        }
        .btns {
          padding: 0 20px 40px;
          span,
          a {
            color: #fff;
            font-weight: 700;
            width: 99px;
            height: 31px;
            background-color: rgba(255, 141, 26, 1);
            display: inline-block;
            line-height: 31px;
            border-radius: 4px;
          }
        }
      }
      .api {
        img {
          width: 150px;
          height: 150px;
        }
        svg {
          width: 50px;
          height: 40px;
        }
        color: #333;
        font-size: 12px;
      }
    }
  }
  .part4 {
    font-size: 0;
    position: relative;
    height: 1758px;
    > p {
      font-size: 36px;
      margin: 50px 0 30px 0;
    }
    .school {
      img {
        height: 120px;
        margin-right: 50px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .small-title {
      font-size: 20px;
      color: #333;
    }
    .div {
      width: 1054px;
      margin: 30px auto 0;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 199;
      img {
        width: 438px;
        height: 245px;
      }
      .explain {
        width: 460px;
        margin-bottom: 100px;
        text-align: left;
        p {
          font-size: 16px;
          color: #333;
        }
        .green {
          margin-top: 20px;
          font-weight: 700;
          color: #70b603;
        }
      }
    }
    .bg3 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
      bottom: 350px;
      width: 1200px;
      height: 701px;
    }
  }
  .collaspe {
    width: 422px;
    margin: 0 auto;
    padding-bottom: 40px;
    > p {
      font-size: 36px;
      margin: 30px 0;
    }
    .btn {
      font-weight: 700;
      background: rgba(255, 141, 26, 1);
      font-size: 15px;
      line-height: 40px;
      border-radius: 6px;
      display: inline-block;
      width: 142px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/parents.vue